module.exports = __webpack_public_path__ + "img/icon_process_03.21326edf.svg";